import { Injectable} from '@angular/core';

import { environment } from '../../../environments/environment';
import {AppUrlConfig} from '../../common/core/services/base/appUrlConfig';

@Injectable({   providedIn: 'root' })
export class AppUrlConfigImplem extends AppUrlConfig {
  urls = {
    baseUrl: `${environment.baseUrl}/api_faq/`,
    list: { articles: 'articles/',
            articlesadmin: 'articlesadmin/',
            categories: 'categories/',
            categoriesadmin: 'categoriesadmin/',
            icons: 'icons/',
            manageroles: 'manage_droits/',
            individus: 'individus/',
            stats: 'stats/'
    }
  };
}
